module.exports = __webpack_public_path__ + "static/media/Ending.67832539.mp3";